import { render, staticRenderFns } from "./AssayStatusRenderer.vue?vue&type=template&id=60e41786&"
import script from "./AssayStatusRenderer.vue?vue&type=script&lang=js&"
export * from "./AssayStatusRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports